module.exports = __webpack_public_path__ + "static/img/huanghe.589bc4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/people/huanghe.jpg
// module id = BAPM
// module chunks = 2